import React, {Fragment, useState} from 'react';
import { useDispatch, useSelector } from "react-redux";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";
import useForm from "../../hooks/useForm";
import {datosMotoForm, datosMotoConstraints} from "./DatosMotoForm";
import Spinner from "../../components/Spinner";
import axios from "../../axios";
import { requests } from '../../constants/config';
import { EXITO, NO_DATA } from '../../constants/enviroment';
import { setParametrosBusqueda } from "../../actions/busqueda/busquedaAction";

const DatosMoto = (props) => {
    const dispatch = useDispatch();
    const params = useSelector(state => state.parametrosBusqueda);
    console.log(params);
    const [buscando, setIsBuscando] = useState(false);
    const [error, setErrores] = useState('');
    
    const {
        handleFormChange,
        isFormValid,
        getValue
    } = useForm(datosMotoForm, datosMotoConstraints);

    const setForm = async (event) => {
        handleFormChange(event);
    };

    const disabledButton = () => {
        return !isFormValid();
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsBuscando(true);
        setErrores('');

        let data = {
            numSerie: getValue("numSerie"),
            numMotor: getValue("numMotor")
        }
        axios.post(requests.facturacionMoto.validarMoto, data)
        .then(res => {
            //console.log(res.data);
            let code = res.data.mensaje.codigo;
            let mensaje = res.data.mensaje.descripcion;
            let idCompra = res.data.idNetsuite;
            let parametrosBusqueda = {
                idCompra
            }
            dispatch(setParametrosBusqueda(parametrosBusqueda));
            setIsBuscando(false);

            if(code === EXITO) {
                props.nextStep();
            } else if(code === NO_DATA) {
                setErrores(mensaje);
            } else {
                setErrores('Ocurrió un error, verifique sus datos de búsqueda.');
            }
        })
    };

    return (
        <Fragment>
            <h3>Ingrese los datos de la motocicleta.</h3>
        
            {(error !== null && error !== '') ?
                <div className="alert alert-warning" role="alert">
                    <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                    icon={faExclamationTriangle}/> {error}
                </div> : ''
            }

            <form onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="form-group col-xs-12 col-md-6">
                        <label htmlFor="numSerie">Número de Serie*:</label> 
                        <input
                            className="form-control" id="numSerie" name="numSerie"                         
                            value={getValue('numSerie') || ''}
                            onChange={setForm}
                            disabled={buscando}
                            placeholder="Número de serie"
                            maxLength="20"
                            autoComplete="off"
                        />
                    </div>
                    <div className="form-group col-xs-12 col-md-6">
                        <label htmlFor="numMotor">Número de Motor*:</label>   
                        <input
                            className="form-control" id="numMotor" name="numMotor"                         
                            value={getValue('numMotor') || ''}
                            onChange={setForm}
                            disabled={buscando}
                            placeholder="Número de motor"
                            maxLength="20"
                            autoComplete="off"
                        />
                    </div>
                </div>
                <button type="submit" className="btn btn-lg btn-chapur btn-block mt-30"
                        disabled={buscando || disabledButton()}>
                    {!buscando ? 'Validar' : 'Validando...'}
                    {buscando && <Spinner/>}
                </button>
            </form>
        </Fragment>
    );
};

export default DatosMoto;